/* eslint-disable */
import * as React from 'react';
import {
  Avatar, Badge, Box, Button, Collapse, Divider, Flex, FormControl, FormLabel, HStack, Icon,
  IconButton, Image, Input, InputGroup, InputRightElement, Modal, ModalBody, ModalCloseButton,
  ModalContent, ModalFooter, ModalOverlay, Select, SimpleGrid, Stack, Table,
  Tbody, Td, Text, Th, Thead, Tooltip, Tr, useColorModeValue, useDisclosure, useToast,
} from '@chakra-ui/react';
import {
  ColumnFiltersState, PaginationState, createColumnHelper, flexRender,
  getCoreRowModel, getFacetedMinMaxValues, getFacetedRowModel, getFacetedUniqueValues,
  getFilteredRowModel, getPaginationRowModel, getSortedRowModel, useReactTable,
} from '@tanstack/react-table';
import { useForm } from 'react-hook-form';
import { MdCancel, MdChevronLeft, MdChevronRight, MdDownload, MdFilterList, MdHowToVote, MdInfo, MdLoupe, MdRefresh, MdUpload, MdVisibility, MdVisibilityOff } from 'react-icons/md';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';

type RowObj = {
  id: number; Nombre: string; ApellidoP: string; ApellidoM: string;
  RFC: string; CURP: string; Fotografia: string; LogoPartido: string;
  Partido: string; Lema: string; Estado: string; Municipio: string;
  CorreoElectronico: string; Nacimiento: string;
  Bloqueado: boolean; createdAt: string;
};

const estatusBadge = (b: boolean) => b
  ? { colorScheme: 'red', label: 'Bloqueado' }
  : { colorScheme: 'green', label: 'Activo' };

const inputStyle = {
  variant: 'filled' as const,
  borderRadius: 'lg',
  _focus: { bg: 'white', borderColor: 'brand.500', boxShadow: '0 0 0 1px var(--chakra-colors-brand-500)' },
};

export default function SearchTableOrders(props: { tableData: any }) {
  const { tableData } = props;
  const toast = useToast();
  const filterBg = useColorModeValue('gray.50', 'navy.900');
  const textColor = useColorModeValue('navy.700', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const brandColor = useColorModeValue('brand.500', 'brand.400');
  const rowHover = useColorModeValue('gray.50', 'whiteAlpha.50');

  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isOpen: isOpenNuevo, onOpen: onOpenNuevo, onClose: onCloseNuevo } = useDisclosure();
  const { isOpen: isOpenImg, onOpen: onOpenImg, onClose: onCloseImg } = useDisclosure();
  const [orden, setOrden] = React.useState(0);
  const [selectedCandidato, setSelectedCandidato] = React.useState<RowObj | null>(null);

  const [showFilters, setShowFilters] = React.useState(false);
  const [estatusFilter, setEstatusFilter] = React.useState<'Todos' | 'Activo' | 'Bloqueado'>('Todos');
  const [partidoFilter, setPartidoFilter] = React.useState('');
  const [fechaDesde, setFechaDesde] = React.useState('');
  const [fechaHasta, setFechaHasta] = React.useState('');
  const [reportDesde, setReportDesde] = React.useState('');
  const [reportHasta, setReportHasta] = React.useState('');

  const activeFilters = [estatusFilter !== 'Todos', !!partidoFilter, !!(fechaDesde || fechaHasta)].filter(Boolean).length;
  const resetFilters = () => { setEstatusFilter('Todos'); setPartidoFilter(''); setFechaDesde(''); setFechaHasta(''); };

  const [data, setData] = React.useState<RowObj[]>(() => [...tableData]);
  const [globalFilter, setGlobalFilter] = React.useState('');
  const [columnFilters, setColumnFilters] = React.useState<ColumnFiltersState>([]);
  const [{ pageIndex, pageSize }, setPagination] = React.useState<PaginationState>({ pageIndex: 0, pageSize: 8 });
  const pagination = React.useMemo(() => ({ pageIndex, pageSize }), [pageIndex, pageSize]);

  const filteredData = React.useMemo(() => data.filter((r) => {
    if (estatusFilter === 'Activo' && r.Bloqueado) return false;
    if (estatusFilter === 'Bloqueado' && !r.Bloqueado) return false;
    if (partidoFilter && r.Partido !== partidoFilter) return false;
    if (fechaDesde || fechaHasta) {
      const d = r.createdAt ? new Date(r.createdAt) : null;
      if (!d) return false;
      if (fechaDesde && d < new Date(fechaDesde)) return false;
      if (fechaHasta && d > new Date(fechaHasta + 'T23:59:59')) return false;
    }
    return true;
  }), [data, estatusFilter, partidoFilter, fechaDesde, fechaHasta]);

  const uniquePartidos = React.useMemo(() => [...new Set(data.map((r) => r.Partido).filter(Boolean))].sort(), [data]);

  const counts = React.useMemo(() => ({
    total: data.length,
    activos: data.filter((r) => !r.Bloqueado).length,
    bloqueados: data.filter((r) => r.Bloqueado).length,
  }), [data]);

  const { handleSubmit, register, reset, formState: { isSubmitting } } = useForm();
  const [showPass, setShowPass] = React.useState(false);
  const fileRefFoto = React.useRef<HTMLInputElement>(null);
  const fileRefLogo = React.useRef<HTMLInputElement>(null);
  const [fileFoto, setFileFoto] = React.useState<File | null>(null);
  const [fileLogo, setFileLogo] = React.useState<File | null>(null);
  const [previewFoto, setPreviewFoto] = React.useState<string | null>(null);
  const [previewLogo, setPreviewLogo] = React.useState<string | null>(null);

  const refreshTable = async () => {
    const d = await fetch(process.env.REACT_APP_URL_SERVER + '/candidatos', { credentials: 'include' }).then(r => r.json()).catch(() => null);
    if (d) setData(d);
  };

  const onSubmitNuevo = async (values: any) => {
    const fd = new FormData();
    for (const k in values) fd.append(k, values[k]);
    if (fileFoto) fd.append('Fotografia', fileFoto);
    if (fileLogo) fd.append('LogoPartido', fileLogo);
    const res = await fetch(process.env.REACT_APP_URL_SERVER + '/new_candidato', { method: 'POST', body: fd, credentials: 'include' });
    if (res.ok) {
      toast({ title: 'Candidato registrado', status: 'success', duration: 3000 });
      reset(); setFileFoto(null); setFileLogo(null); setPreviewFoto(null); setPreviewLogo(null); onCloseNuevo(); await refreshTable();
    } else toast({ title: 'Error al guardar', status: 'error', duration: 3000 });
  };

  const columnHelper = createColumnHelper<RowObj>();
  const columns = [
    columnHelper.accessor('Fotografia', {
      id: 'foto', header: () => <Flex />,
      cell: (info) => <Avatar size="md" src={info.getValue()} name={info.row.original.Nombre} />,
    }),
    columnHelper.accessor('Nombre', {
      id: 'nombre',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400" fontWeight="700">CANDIDATO</Text>,
      cell: (info) => {
        const r = info.row.original;
        return (
          <Box>
            <Text color={textColor} fontWeight="600" fontSize="sm">{r.Nombre} {r.ApellidoP} {r.ApellidoM}</Text>
            <Text color="gray.400" fontSize="xs">{r.RFC}</Text>
          </Box>
        );
      },
    }),
    columnHelper.accessor('Partido', {
      id: 'partido',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400" fontWeight="700">PARTIDO</Text>,
      cell: (info) => <Badge colorScheme="blue" fontSize="xs" borderRadius="md" px="2">{info.getValue()}</Badge>,
    }),
    columnHelper.accessor('LogoPartido', {
      id: 'logo', header: () => <Flex />,
      cell: (info) => <Avatar size="sm" src={info.getValue()} name="logo" />,
    }),
    columnHelper.accessor('createdAt', {
      id: 'registro',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400" fontWeight="700">REGISTRO</Text>,
      cell: (info) => {
        const v = info.getValue();
        return <Text color="gray.500" fontSize="xs">{v ? new Date(v).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' }) : '—'}</Text>;
      },
    }),
    columnHelper.accessor('Bloqueado', {
      id: 'estatus',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400" fontWeight="700">ESTATUS</Text>,
      cell: (info) => {
        const { colorScheme, label } = estatusBadge(info.getValue());
        return <Badge colorScheme={colorScheme} fontSize="xs" borderRadius="full" px="3" py="1">{label}</Badge>;
      },
    }),
    columnHelper.accessor('id', {
      id: 'actions',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400" fontWeight="700">ACCIONES</Text>,
      cell: (info) => (
        <HStack spacing="2px">
          <Tooltip label="Ver detalle"><IconButton aria-label="detalle" size="sm" variant="ghost" colorScheme="gray" icon={<Icon as={MdLoupe} h="18px" w="18px" />} onClick={() => { setOrden(info.getValue()); setSelectedCandidato(info.row.original); onOpen(); }} /></Tooltip>
          <Tooltip label="Bloquear"><IconButton aria-label="bloquear" size="sm" variant="ghost" colorScheme="red" icon={<Icon as={MdCancel} h="18px" w="18px" />} onClick={() => toast({ title: 'Acción no configurada', status: 'warning', duration: 2000 })} /></Tooltip>
        </HStack>
      ),
    }),
  ];

  const table = useReactTable({
    data: filteredData, columns,
    state: { columnFilters, globalFilter, pagination },
    onPaginationChange: setPagination, onColumnFiltersChange: setColumnFilters, onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(), getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(), getPaginationRowModel: getPaginationRowModel(),
    getFacetedRowModel: getFacetedRowModel(), getFacetedUniqueValues: getFacetedUniqueValues(), getFacetedMinMaxValues: getFacetedMinMaxValues(),
  });
  const createPages = (n: number) => Array.from({ length: n }, (_, i) => i + 1);

  return (
    <Flex direction="column" w="100%" overflowX={{ sm: 'scroll', lg: 'hidden' }}>
      {/* Toolbar */}
      <Flex align="center" justify="space-between" w="100%" px="22px" mb="16px" flexWrap="wrap" gap="10px">
        <DebouncedInput value={globalFilter ?? ''} onChange={(v) => setGlobalFilter(String(v))} placeholder="Buscar candidato..." />
        <HStack spacing="8px">
          <Tooltip label="Actualizar"><IconButton aria-label="refresh" size="md" variant="outline" icon={<Icon as={MdRefresh} h="18px" w="18px" />} onClick={refreshTable} /></Tooltip>
          <Button variant="outline" fontSize="sm" leftIcon={<Icon as={MdFilterList} />} onClick={() => setShowFilters(v => !v)} position="relative">
            Filtros
            {activeFilters > 0 && <Badge colorScheme="brand" borderRadius="full" position="absolute" top="-6px" right="-6px" fontSize="10px" minW="18px" h="18px" display="flex" alignItems="center" justifyContent="center">{activeFilters}</Badge>}
          </Button>
          <Button variant="brand" fontSize="sm" fontWeight="500" onClick={onOpenNuevo}>+ Nuevo Candidato</Button>
        </HStack>
      </Flex>

      {/* Summary chips */}
      <Flex px="22px" mb="12px" gap="8px" flexWrap="wrap">
        {[{ label: 'Todos', val: 'Todos' as const, count: counts.total, color: 'gray' }, { label: 'Activo', val: 'Activo' as const, count: counts.activos, color: 'green' }, { label: 'Bloqueado', val: 'Bloqueado' as const, count: counts.bloqueados, color: 'red' }].map(f => (
          <Badge key={f.val} colorScheme={estatusFilter === f.val ? f.color : 'gray'} variant={estatusFilter === f.val ? 'solid' : 'outline'} fontSize="xs" px="3" py="1" borderRadius="full" cursor="pointer" onClick={() => { setEstatusFilter(f.val); setPagination(p => ({ ...p, pageIndex: 0 })); }} _hover={{ opacity: 0.8 }} userSelect="none">{f.label} ({f.count})</Badge>
        ))}
        {activeFilters > 0 && <Badge colorScheme="orange" variant="outline" fontSize="xs" px="3" py="1" borderRadius="full" cursor="pointer" onClick={resetFilters} _hover={{ opacity: 0.8 }} userSelect="none">✕ Limpiar</Badge>}
      </Flex>

      {/* Filter panel */}
      <Collapse in={showFilters} animateOpacity>
        <Box mx="22px" mb="16px" p="16px" bg={filterBg} borderRadius="12px" border="1px solid" borderColor={borderColor}>
          <Text fontSize="sm" fontWeight="700" color={textColor} mb="14px">Filtros avanzados</Text>
          <SimpleGrid columns={{ base: 1, md: 3 }} gap="16px">
            <Box>
              <FormLabel fontSize="xs" fontWeight="600" color="gray.500" mb="6px">PARTIDO</FormLabel>
              <Select size="sm" borderRadius="8px" value={partidoFilter} onChange={(e) => { setPartidoFilter(e.target.value); setPagination(p => ({ ...p, pageIndex: 0 })); }}>
                <option value="">Todos</option>
                {uniquePartidos.map(p => <option key={p} value={p}>{p}</option>)}
              </Select>
            </Box>
            <Box>
              <FormLabel fontSize="xs" fontWeight="600" color="gray.500" mb="6px">FECHA DE REGISTRO</FormLabel>
              <HStack spacing="8px">
                <Input size="sm" type="date" borderRadius="8px" value={fechaDesde} onChange={(e) => { setFechaDesde(e.target.value); setPagination(p => ({ ...p, pageIndex: 0 })); }} />
                <Text fontSize="xs" color="gray.400">al</Text>
                <Input size="sm" type="date" borderRadius="8px" value={fechaHasta} onChange={(e) => { setFechaHasta(e.target.value); setPagination(p => ({ ...p, pageIndex: 0 })); }} />
              </HStack>
            </Box>
            <Box>
              <FormLabel fontSize="xs" fontWeight="600" color="gray.500" mb="6px">DESCARGAR REPORTE</FormLabel>
              <HStack spacing="8px">
                <Input size="sm" type="date" borderRadius="8px" value={reportDesde} onChange={(e) => setReportDesde(e.target.value)} />
                <Text fontSize="xs" color="gray.400">al</Text>
                <Input size="sm" type="date" borderRadius="8px" value={reportHasta} onChange={(e) => setReportHasta(e.target.value)} />
                <Tooltip label="Descargar Excel">
                  <IconButton aria-label="reporte" size="sm" colorScheme="teal" icon={<Icon as={MdDownload} />}
                    onClick={() => { if (reportDesde && reportHasta) window.location.replace(`${process.env.REACT_APP_URL_SERVER}/registros_candidatos?FechaI=${new Date(reportDesde).toLocaleDateString('en-US')}&FechaF=${new Date(reportHasta).toLocaleDateString('en-US')}`); }} />
                </Tooltip>
              </HStack>
            </Box>
          </SimpleGrid>
          <Flex mt="14px" justify="flex-end"><Button size="sm" variant="ghost" colorScheme="red" onClick={resetFilters}>Limpiar filtros</Button></Flex>
        </Box>
      </Collapse>
      {activeFilters > 0 && <Text px="22px" mb="8px" fontSize="xs" color="gray.500">Mostrando <strong>{filteredData.length}</strong> de {data.length} registros</Text>}

      {/* Detail Modal */}
      <Modal isOpen={isOpen} onClose={onClose} size="xl" scrollBehavior="inside" motionPreset="slideInBottom">
        <ModalOverlay backdropFilter="blur(4px)" bg="blackAlpha.400" />
        <ModalContent borderRadius="2xl" overflow="hidden" mx={4}>
          {/* Header con banner de partido */}
          <Box bg="brand.500" px={6} py={4}>
            <HStack justify="space-between" align="center">
              <HStack gap={3}>
                <Icon as={MdHowToVote} color="white" w={5} h={5} />
                <Text color="white" fontWeight="700" fontSize="lg">Ficha de Candidato</Text>
              </HStack>
              <ModalCloseButton position="static" color="white" _hover={{ bg: 'whiteAlpha.300' }} borderRadius="lg" />
            </HStack>
          </Box>
          <ModalBody px={6} py={5}>
            {selectedCandidato && (
              <>
                {/* Hero: foto + logo + nombre */}
                <Flex gap={4} align="flex-start" mb={5}>
                  <Box position="relative" flexShrink={0}>
                    <Image
                      src={selectedCandidato.Fotografia}
                      fallback={<Avatar size="xl" name={`${selectedCandidato.Nombre} ${selectedCandidato.ApellidoP}`} />}
                      boxSize="90px"
                      borderRadius="xl"
                      objectFit="cover"
                      border="3px solid"
                      borderColor="brand.200"
                      cursor={selectedCandidato.Fotografia ? 'zoom-in' : 'default'}
                      _hover={selectedCandidato.Fotografia ? { opacity: 0.85, transform: 'scale(1.02)' } : {}}
                      transition="all 0.2s"
                      onClick={() => selectedCandidato.Fotografia && onOpenImg()}
                    />
                    {selectedCandidato.LogoPartido && (
                      <Avatar
                        src={selectedCandidato.LogoPartido}
                        name="logo"
                        size="sm"
                        position="absolute"
                        bottom="-8px"
                        right="-8px"
                        border="2px solid white"
                        bg="white"
                      />
                    )}
                  </Box>
                  <Box flex={1}>
                    <Text fontWeight="700" fontSize="lg" color={textColor} lineHeight="1.2">
                      {selectedCandidato.Nombre} {selectedCandidato.ApellidoP} {selectedCandidato.ApellidoM}
                    </Text>
                    <HStack mt={2} flexWrap="wrap" gap={2}>
                      <Badge colorScheme="blue" borderRadius="full" px={3}>{selectedCandidato.Partido || 'Sin partido'}</Badge>
                      <Badge colorScheme={selectedCandidato.Bloqueado ? 'red' : 'green'} borderRadius="full" px={3}>
                        {selectedCandidato.Bloqueado ? 'Bloqueado' : 'Activo'}
                      </Badge>
                    </HStack>
                    {selectedCandidato.Lema && (
                      <Text mt={2} fontSize="sm" color="gray.500" fontStyle="italic">
                        "{selectedCandidato.Lema}"
                      </Text>
                    )}
                  </Box>
                </Flex>

                <Divider mb={4} />

                {/* Datos personales */}
                <Text fontSize="xs" fontWeight="700" textTransform="uppercase" letterSpacing="wide" color="gray.400" mb={3}>
                  Datos Personales
                </Text>
                <SimpleGrid columns={{ base: 1, md: 2 }} gap={4} mb={5}>
                  <CField label="RFC" value={selectedCandidato.RFC || '—'} />
                  <CField label="CURP" value={selectedCandidato.CURP || '—'} />
                  <CField label="Correo Electrónico" value={selectedCandidato.CorreoElectronico || '—'} />
                  <CField label="Fecha de Nacimiento" value={
                    selectedCandidato.Nacimiento
                      ? new Date(selectedCandidato.Nacimiento).toLocaleDateString('es-MX', { day: '2-digit', month: 'long', year: 'numeric' })
                      : '—'
                  } />
                  <CField label="Estado" value={selectedCandidato.Estado || '—'} />
                  <CField label="Municipio" value={selectedCandidato.Municipio || '—'} />
                  <CField label="Fecha de Registro" value={
                    selectedCandidato.createdAt
                      ? new Date(selectedCandidato.createdAt).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' })
                      : '—'
                  } />
                </SimpleGrid>

                {/* Logo del partido */}
                {selectedCandidato.LogoPartido && (
                  <>
                    <Divider mb={4} />
                    <Text fontSize="xs" fontWeight="700" textTransform="uppercase" letterSpacing="wide" color="gray.400" mb={3}>
                      Logo del Partido
                    </Text>
                    <Box
                      as="img"
                      src={selectedCandidato.LogoPartido}
                      alt="Logo partido"
                      maxH="80px"
                      objectFit="contain"
                      borderRadius="lg"
                      bg="gray.50"
                      p={2}
                    />
                  </>
                )}
              </>
            )}
          </ModalBody>
          <ModalFooter borderTop="1px solid" borderColor="gray.100" gap={3} px={6} py={4}>
            <Button variant="ghost" borderRadius="xl" onClick={onClose}>Cerrar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Lightbox foto */}
      <Modal isOpen={isOpenImg} onClose={onCloseImg} size="4xl" isCentered motionPreset="scale">
        <ModalOverlay backdropFilter="blur(10px)" bg="blackAlpha.800" />
        <ModalContent bg="transparent" shadow="none" mx={4}>
          <ModalCloseButton color="white" size="lg" zIndex={10} top={2} right={2} bg="blackAlpha.500" borderRadius="full" />
          <ModalBody p={0} display="flex" justifyContent="center" alignItems="center">
            <Box
              as="img"
              src={selectedCandidato?.Fotografia}
              alt="Foto candidato"
              borderRadius="2xl"
              maxH="85vh"
              maxW="100%"
              objectFit="contain"
            />
          </ModalBody>
        </ModalContent>
      </Modal>

      {/* Nuevo Candidato Modal */}
      <Modal isOpen={isOpenNuevo} onClose={onCloseNuevo} size="3xl" scrollBehavior="inside" motionPreset="slideInBottom">
        <ModalOverlay backdropFilter="blur(4px)" bg="blackAlpha.400" />
        <ModalContent borderRadius="2xl" overflow="hidden" mx={4}>
          <Box bg="brand.500" px={6} py={4}>
            <HStack justify="space-between" align="center">
              <HStack gap={3}>
                <Icon as={MdHowToVote} color="white" w={5} h={5} />
                <Text color="white" fontWeight="700" fontSize="lg">Registrar Nuevo Candidato</Text>
              </HStack>
              <ModalCloseButton position="static" color="white" _hover={{ bg: 'whiteAlpha.300' }} borderRadius="lg" />
            </HStack>
          </Box>
          <form onSubmit={handleSubmit(onSubmitNuevo)}>
            <ModalBody px={6} py={5}>
              <SimpleGrid columns={{ base: 1, md: 2 }} gap="20px">
                <Stack gap="14px">
                  <FField label="Nombre"><Input placeholder="Juan" {...inputStyle} {...register('Nombre', { required: true })} /></FField>
                  <FField label="Apellido Paterno"><Input placeholder="Pérez" {...inputStyle} {...register('ApellidoP', { required: true })} /></FField>
                  <FField label="Apellido Materno"><Input placeholder="García" {...inputStyle} {...register('ApellidoM', { required: true })} /></FField>
                  <FField label="RFC"><Input placeholder="PEGJ800101AAA" {...inputStyle} {...register('RFC')} /></FField>
                  <FField label="CURP"><Input placeholder="PEGJ800101HJCRRC01" {...inputStyle} {...register('CURP')} /></FField>
                  <FField label="Correo Electrónico"><Input type="email" placeholder="juan@partido.mx" {...inputStyle} {...register('CorreoElectronico')} /></FField>
                </Stack>
                <Stack gap="14px">
                  <FField label="Partido"><Input placeholder="Partido Nacional" {...inputStyle} {...register('Partido')} /></FField>
                  <FField label="Lema"><Input placeholder="Por un mejor futuro" {...inputStyle} {...register('Lema')} /></FField>
                  <FField label="Estado"><Input placeholder="Jalisco" {...inputStyle} {...register('Estado')} /></FField>
                  <FField label="Municipio"><Input placeholder="Guadalajara" {...inputStyle} {...register('Municipio')} /></FField>
                  <FField label="Fecha de Nacimiento"><Input type="date" {...inputStyle} {...register('Nacimiento')} /></FField>
                  <FField label="Contraseña">
                    <InputGroup>
                      <Input type={showPass ? 'text' : 'password'} placeholder="••••••••" {...inputStyle} {...register('Password', { required: true })} />
                      <InputRightElement>
                        <IconButton
                          aria-label={showPass ? 'Ocultar' : 'Mostrar'}
                          size="sm"
                          variant="ghost"
                          icon={<Icon as={showPass ? MdVisibilityOff : MdVisibility} h="18px" w="18px" color="gray.400" />}
                          onClick={() => setShowPass((v) => !v)}
                        />
                      </InputRightElement>
                    </InputGroup>
                  </FField>
                  <FField label="Fotografía">
                    <HStack align="flex-start" gap={3}>
                      {previewFoto && (
                        <Box
                          as="img"
                          src={previewFoto}
                          alt="Preview foto"
                          boxSize="72px"
                          objectFit="cover"
                          borderRadius="lg"
                          border="2px solid"
                          borderColor="brand.200"
                          flexShrink={0}
                        />
                      )}
                      <Stack gap={1} flex={1}>
                        <Button size="sm" variant="outline" borderRadius="lg" leftIcon={<Icon as={MdUpload} h="16px" w="16px" />} onClick={() => fileRefFoto.current?.click()}>
                          {fileFoto ? 'Cambiar foto' : 'Subir foto'}
                        </Button>
                        <Text fontSize="xs" color="gray.400" noOfLines={1}>{fileFoto?.name || 'Sin archivo'}</Text>
                      </Stack>
                    </HStack>
                    <input ref={fileRefFoto} type="file" accept=".png,.jpg,.jpeg" style={{ display: 'none' }} onChange={(e) => {
                      const f = e.target.files?.[0] || null;
                      setFileFoto(f);
                      setPreviewFoto(f ? URL.createObjectURL(f) : null);
                    }} />
                  </FField>
                  <FField label="Logo del Partido">
                    <HStack align="flex-start" gap={3}>
                      {previewLogo && (
                        <Box
                          as="img"
                          src={previewLogo}
                          alt="Preview logo"
                          boxSize="72px"
                          objectFit="contain"
                          borderRadius="lg"
                          border="2px solid"
                          borderColor="brand.200"
                          bg="gray.50"
                          flexShrink={0}
                        />
                      )}
                      <Stack gap={1} flex={1}>
                        <Button size="sm" variant="outline" borderRadius="lg" leftIcon={<Icon as={MdUpload} h="16px" w="16px" />} onClick={() => fileRefLogo.current?.click()}>
                          {fileLogo ? 'Cambiar logo' : 'Subir logo'}
                        </Button>
                        <Text fontSize="xs" color="gray.400" noOfLines={1}>{fileLogo?.name || 'Sin archivo'}</Text>
                      </Stack>
                    </HStack>
                    <input ref={fileRefLogo} type="file" accept=".png,.jpg,.jpeg" style={{ display: 'none' }} onChange={(e) => {
                      const f = e.target.files?.[0] || null;
                      setFileLogo(f);
                      setPreviewLogo(f ? URL.createObjectURL(f) : null);
                    }} />
                  </FField>
                </Stack>
              </SimpleGrid>
            </ModalBody>
            <ModalFooter borderTop="1px solid" borderColor="gray.100" gap={3} px={6} py={4}>
              <Button variant="ghost" borderRadius="xl" onClick={() => { reset(); setFileFoto(null); setFileLogo(null); setPreviewFoto(null); setPreviewLogo(null); onCloseNuevo(); }}>Cancelar</Button>
              <Button colorScheme="brand" type="submit" isLoading={isSubmitting} borderRadius="xl" px={8}>Guardar</Button>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>

      {/* Table */}
      <Table variant="simple" color="gray.500" mb="24px">
        <Thead>{table.getHeaderGroups().map(hg => (<Tr key={hg.id}>{hg.headers.map(h => (<Th pe="10px" borderColor={borderColor} key={h.id} colSpan={h.colSpan}>{h.isPlaceholder ? null : (<Flex justify="space-between" align="center" fontSize={{ sm: '10px', lg: '12px' }} color="gray.400" cursor={h.column.getCanSort() ? 'pointer' : 'default'} onClick={h.column.getToggleSortingHandler()}>{flexRender(h.column.columnDef.header, h.getContext())}</Flex>)}</Th>))}</Tr>))}</Thead>
        <Tbody>
          {table.getRowModel().rows.length === 0 ? (<Tr><Td colSpan={columns.length} textAlign="center" py="40px" color="gray.400">Sin registros con los filtros actuales</Td></Tr>) :
            table.getRowModel().rows.map(row => (<Tr key={row.id} _hover={{ bg: rowHover }}>{row.getVisibleCells().map(cell => (<Td key={cell.id} fontSize={{ sm: '14px' }} minW={{ sm: '120px', md: 'auto' }} borderColor={borderColor} py="12px">{flexRender(cell.column.columnDef.cell, cell.getContext())}</Td>))}</Tr>))}
        </Tbody>
      </Table>

      {/* Pagination */}
      <Flex w="100%" justify="space-between" px="20px" pt="10px" pb="5px">
        <Text fontSize="sm" color="gray.500" mb={{ sm: '24px', md: '0px' }}>
          {filteredData.length === 0 ? 'Sin registros' : `${pageSize * pageIndex + 1}–${Math.min(pageSize * (pageIndex + 1), filteredData.length)} de ${filteredData.length}`}
        </Text>
        <Stack direction="row" alignSelf="flex-end" spacing="4px" ms="auto">
          <Button variant="no-effects" onClick={() => table.previousPage()} disabled={!table.getCanPreviousPage()} w="40px" h="40px" borderRadius="50%" bg="transparent" border="1px solid" borderColor={borderColor} display={table.getCanPreviousPage() ? 'flex' : 'none'} _hover={{ opacity: '0.7' }}><Icon as={MdChevronLeft} w="16px" h="16px" color={textColor} /></Button>
          {createPages(table.getPageCount()).map((p, i) => (<Button key={i} variant="no-effects" onClick={() => table.setPageIndex(p - 1)} w="40px" h="40px" borderRadius="50%" bg={p === pageIndex + 1 ? brandColor : 'transparent'} border={p === pageIndex + 1 ? 'none' : '1px solid lightgray'} _hover={p === pageIndex + 1 ? { opacity: '0.7' } : { bg: 'whiteAlpha.100' }}><Text fontSize="sm" color={p === pageIndex + 1 ? '#fff' : textColor}>{p}</Text></Button>))}
          <Button variant="no-effects" onClick={() => table.nextPage()} disabled={!table.getCanNextPage()} w="40px" h="40px" borderRadius="50%" bg="transparent" border="1px solid" borderColor={borderColor} display={table.getCanNextPage() ? 'flex' : 'none'} _hover={{ opacity: '0.7' }}><Icon as={MdChevronRight} w="16px" h="16px" color={textColor} /></Button>
        </Stack>
      </Flex>
    </Flex>
  );
}

function CField({ label, value }: { label: string; value: string }) {
  return (
    <Box>
      <Text fontSize="xs" fontWeight="700" textTransform="uppercase" letterSpacing="wide" color="gray.400" mb="2px">{label}</Text>
      <Text fontSize="sm" fontWeight="500">{value}</Text>
    </Box>
  );
}

function FField({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <FormControl>
      <FormLabel fontSize="xs" fontWeight="700" textTransform="uppercase" letterSpacing="wide" color="gray.500" mb={1}>{label}</FormLabel>
      {children}
    </FormControl>
  );
}

function DebouncedInput({ value: iv, onChange, debounce = 500, ...props }: { value: string | number; onChange: (v: string | number) => void; debounce?: number } & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'>) {
  const [value, setValue] = React.useState(iv);
  React.useEffect(() => { setValue(iv); }, [iv]);
  React.useEffect(() => { const t = setTimeout(() => onChange(value), debounce); return () => clearTimeout(t); }, [value]);
  return <SearchBar {...props} value={value} onChange={(e: any) => setValue(e.target.value)} h="44px" w={{ lg: '390px' }} borderRadius="16px" />;
}
